import script from "./insurance-correct-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-correct-popup.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-correct-popup.vue?vue&type=style&index=0&id=6970d293&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6970d293"]])

export default __exports__